import { render } from "./InlineTabHeader.vue?vue&type=template&id=71abcb7c"
import script from "./InlineTabHeader.vue?vue&type=script&lang=js"
export * from "./InlineTabHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__